import React, { ReactElement } from 'react';
import styles from './DatasourceAccess.module.scss';

export type DatasourceAccessProperties = {
  headerText: string;
  descriptionText: string | ReactElement;
  image: string;
};
export const DatasourceAccess: React.FC<DatasourceAccessProperties> = ({
  headerText,
  descriptionText,
  image,
}) => {
  return (
    <>
      <img src={image} alt="icon" className={styles.image} />
      <h1 className={styles.title}>{headerText}</h1>
      <span className={styles.description}>{descriptionText}</span>
    </>
  );
};

export default DatasourceAccess;
